import { useState, useEffect } from "react";
import { Table } from "@velocity-ehs/component-library";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import { SortDirection } from "../../supportFunctions/graphql/Queries";
import { Columns } from "./EhsConfigurationsColumns";
import { useGetEhsConfigurations } from "../../../hooks/useGetEhsConfigurations";
import { EhsConfiguration } from "./Utils";
import useEhsConfigurationMutations from "../../../hooks/useEhsConfigurationMutations";

const defaultParams = {
  first: 0,
  rows: 20,
  page: 0,
  sortField: "IsActive",
  sortOrder: SortDirection.DESC,
};

type CommonConfigTableProps = {
  configType: string | undefined;
  rowActions: (data: EhsConfiguration) => any[];
  setSelected: (data: any) => void;
};

const CommonConfigTable = ({
  configType,
  setSelected,
  rowActions,
}: CommonConfigTableProps) => {
  const { t } = useTranslation();
  const [lazyParams, setLazyParams] = useState(defaultParams);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const { ehsConfigurations, pagination, isFetching } = useGetEhsConfigurations(
    lazyParams,
    configType ? [configType] : undefined
  );

  const { mutations } = useEhsConfigurationMutations();

  useEffect(() => {
    pagination.totalElements && setTotalRecords(pagination.totalElements);
  }, [pagination]);

  function getTableColumns() {
    return Columns.common.map((column) => {
      return (
        <Column
          key={column.field}
          field={column.field}
          header={t(column.header)}
          sortable={column.sortable}
          body={column.body}
        />
      );
    });
  }

  return (
    <Table
      data={ehsConfigurations}
      params={lazyParams}
      totalRecords={totalRecords}
      selectionMode="single"
      onRowSelect={(e) => setSelected(e)}
      rowActions={rowActions}
      isLoading={isFetching || mutations.isLoading}
      onSort={setLazyParams}
      onPage={setLazyParams}
      testId="common-config-table"
    >
      {getTableColumns()}
    </Table>
  );
};

export default CommonConfigTable;
